import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import reservationReducer from "../redux/Features/Reservation/ReservationSlice";
import tokenReducer from "../redux/Features/Token/TokenSlice";
import sidebarReducer from "../redux/Features/Sidebar/SidebarSlice";

export default configureStore({
  reducer: {
    reservation: reservationReducer,
    token: tokenReducer,
    sidebar: sidebarReducer,
  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});
